export const profileUser = {
  name: 'Дмитрий Козлов',
  email: 'dmitry.kozlov@mail.ru',
  phone: '+7 (916) 234-56-78',
  birthDate: '1988-03-14',
  avatar: 'https://public.readdy.ai/ai/img_res/ed764fd80bc3c0004f521a1e195250a0.jpg',
  level: 'GOLD',
  bonusPoints: 3248,
  totalSpent: 47820,
  ordersCount: 23,
  memberSince: 'Март 2023',
  nextLevelPoints: 5000,
  cashbackRate: 3,
};

export const profileOrders = [
  {
    id: 'NP-2026-0312',
    date: '12 марта 2026',
    status: 'delivered',
    statusLabel: 'Доставлен',
    total: 2847,
    bonusEarned: 85,
    deliveryType: 'Курьер',
    address: 'ул. Тверская, 15, кв. 42',
    items: [
      { name: 'Нурофен Экспресс 200 мг, 16 шт', qty: 2, price: 312, image: 'https://readdy.ai/api/search-image?query=ibuprofen%20pain%20relief%20capsules%20blister%20pack%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=200&height=200&seq=ord1_1&orientation=squarish' },
      { name: 'Магне B6 Таблетки, 60 шт', qty: 1, price: 890, image: 'https://readdy.ai/api/search-image?query=magnesium%20B6%20vitamin%20supplement%20tablets%20box%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean&width=200&height=200&seq=ord1_2&orientation=squarish' },
      { name: 'Омепразол 20 мг, 30 шт', qty: 3, price: 189, image: 'https://readdy.ai/api/search-image?query=omeprazole%20stomach%20medicine%20capsules%20blister%20pack%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean&width=200&height=200&seq=ord1_3&orientation=squarish' },
    ],
  },
  {
    id: 'NP-2026-0287',
    date: '28 февраля 2026',
    status: 'delivered',
    statusLabel: 'Доставлен',
    total: 4290,
    bonusEarned: 129,
    deliveryType: 'Самовывоз',
    address: 'NEON PHARMA — Центр, ул. Тверская, 15',
    items: [
      { name: 'NeuroPlex Ultra 500 мг, 60 шт', qty: 1, price: 4290, image: 'https://readdy.ai/api/search-image?query=futuristic%20white%20supplement%20capsule%20bottle%20glowing%20pink%20neon%20aura%20dark%20black%20background%20cyberpunk%20pharmaceutical%20product%20photography%20minimal&width=200&height=200&seq=ord2_1&orientation=squarish' },
    ],
  },
  {
    id: 'NP-2026-0241',
    date: '14 февраля 2026',
    status: 'delivered',
    statusLabel: 'Доставлен',
    total: 1456,
    bonusEarned: 44,
    deliveryType: 'Курьер',
    address: 'ул. Тверская, 15, кв. 42',
    items: [
      { name: 'Кардиомагнил 75 мг, 100 шт', qty: 2, price: 363, image: 'https://readdy.ai/api/search-image?query=aspirin%20cardio%20heart%20medicine%20tablets%20blister%20pack%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=200&height=200&seq=ord3_1&orientation=squarish' },
      { name: 'Зодак 10 мг, 30 шт', qty: 1, price: 265, image: 'https://readdy.ai/api/search-image?query=antihistamine%20allergy%20medicine%20tablets%20blister%20pack%20yellow%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean&width=200&height=200&seq=ord3_2&orientation=squarish' },
      { name: 'Линекс Капсулы, 32 шт', qty: 1, price: 567, image: 'https://readdy.ai/api/search-image?query=probiotic%20capsules%20medicine%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20sharp%20photography&width=200&height=200&seq=ord3_3&orientation=squarish' },
    ],
  },
  {
    id: 'NP-2026-0198',
    date: '3 февраля 2026',
    status: 'cancelled',
    statusLabel: 'Отменён',
    total: 890,
    bonusEarned: 0,
    deliveryType: 'Курьер',
    address: 'ул. Тверская, 15, кв. 42',
    items: [
      { name: 'Троксевазин Гель 2%, 100 г', qty: 1, price: 895, image: 'https://readdy.ai/api/search-image?query=vein%20gel%20tube%20medicine%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20sharp%20photography&width=200&height=200&seq=ord4_1&orientation=squarish' },
    ],
  },
  {
    id: 'NP-2026-0156',
    date: '18 января 2026',
    status: 'delivered',
    statusLabel: 'Доставлен',
    total: 6780,
    bonusEarned: 203,
    deliveryType: 'Курьер',
    address: 'ул. Тверская, 15, кв. 42',
    items: [
      { name: 'Эссенциале Форте Н 300 мг, 90 шт', qty: 1, price: 2014, image: 'https://readdy.ai/api/search-image?query=liver%20health%20capsules%20medicine%20yellow%20orange%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20photography%20sharp%20minimal%20clean&width=200&height=200&seq=ord5_1&orientation=squarish' },
      { name: 'Венарус 900+100 мг, 60 шт', qty: 1, price: 3395, image: 'https://readdy.ai/api/search-image?query=vein%20health%20medicine%20tablets%20box%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=200&height=200&seq=ord5_2&orientation=squarish' },
      { name: 'Аквадетрим Витамин D3, 10 мл', qty: 2, price: 580, image: 'https://readdy.ai/api/search-image?query=vitamin%20D3%20drops%20small%20glass%20bottle%20dropper%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=200&height=200&seq=ord5_3&orientation=squarish' },
    ],
  },
];

export const profileFavorites = [
  { id: 1, name: 'Кардиомагнил 75 мг, 100 шт', price: 363, oldPrice: 480, color: '#ff2d78', image: 'https://readdy.ai/api/search-image?query=aspirin%20cardio%20heart%20medicine%20tablets%20blister%20pack%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=300&height=300&seq=fav1&orientation=squarish', inStock: true },
  { id: 9, name: 'Эссенциале Форте Н 300 мг, 90 шт', price: 2014, oldPrice: 2600, color: '#f0ff00', image: 'https://readdy.ai/api/search-image?query=liver%20health%20capsules%20medicine%20yellow%20orange%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20photography%20sharp%20minimal%20clean&width=300&height=300&seq=fav2&orientation=squarish', inStock: true },
  { id: 10, name: 'Аквадетрим Витамин D3, 10 мл', price: 580, oldPrice: 720, color: '#00f5ff', image: 'https://readdy.ai/api/search-image?query=vitamin%20D3%20drops%20small%20glass%20bottle%20dropper%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=300&height=300&seq=fav3&orientation=squarish', inStock: true },
  { id: 22, name: 'Но-шпа 40 мг, 100 шт', price: 345, oldPrice: 430, color: '#ff2d78', image: 'https://readdy.ai/api/search-image?query=no-spa%20drotaverine%20antispasmodic%20tablets%20blister%20pack%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean&width=300&height=300&seq=fav4&orientation=squarish', inStock: true },
  { id: 17, name: 'Магне B6 Таблетки, 60 шт', price: 890, oldPrice: 1100, color: '#00f5ff', image: 'https://readdy.ai/api/search-image?query=magnesium%20B6%20vitamin%20supplement%20tablets%20box%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean&width=300&height=300&seq=fav5&orientation=squarish', inStock: false },
  { id: 21, name: 'Омега-3 1000 мг, 60 шт', price: 780, oldPrice: 980, color: '#39ff14', image: 'https://readdy.ai/api/search-image?query=omega%203%20fish%20oil%20capsules%20bottle%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=300&height=300&seq=fav6&orientation=squarish', inStock: true },
];

export interface UsedPromoCode {
  id: number;
  code: string;
  title: string;
  discount: string;
  discountType: 'percent' | 'fixed' | 'free_delivery';
  savedAmount: number;
  usedAt: string;
  orderId: string;
  color: string;
  icon: string;
  category: string;
}

export const usedPromoCodes: UsedPromoCode[] = [
  {
    id: 1, code: 'VIT40', title: 'Суперскидка на витамины',
    discount: '-40%', discountType: 'percent', savedAmount: 480,
    usedAt: '12 марта 2026', orderId: 'NP-2026-0312',
    color: '#ff2d78', icon: 'ri-capsule-line', category: 'Витамины и БАД',
  },
  {
    id: 2, code: 'HEART30', title: 'Неделя сердца',
    discount: '-30%', discountType: 'percent', savedAmount: 312,
    usedAt: '14 февраля 2026', orderId: 'NP-2026-0241',
    color: '#00f5ff', icon: 'ri-heart-3-line', category: 'Сердце и сосуды',
  },
  {
    id: 3, code: 'FIRST500', title: 'Скидка для новых клиентов',
    discount: '-500 ₽', discountType: 'fixed', savedAmount: 500,
    usedAt: '18 января 2026', orderId: 'NP-2026-0156',
    color: '#39ff14', icon: 'ri-user-add-line', category: 'Для новых клиентов',
  },
  {
    id: 4, code: 'FREERUN', title: 'Бесплатная доставка',
    discount: 'Бесплатно', discountType: 'free_delivery', savedAmount: 199,
    usedAt: '28 февраля 2026', orderId: 'NP-2026-0287',
    color: '#f0ff00', icon: 'ri-truck-line', category: 'Доставка',
  },
  {
    id: 5, code: 'STOMACH15', title: 'Здоровье ЖКТ',
    discount: '-15%', discountType: 'percent', savedAmount: 145,
    usedAt: '10 декабря 2025', orderId: 'NP-2025-0891',
    color: '#39ff14', icon: 'ri-mental-health-line', category: 'Пищеварение',
  },
];

export interface SavedPromo {
  id: number;
  promoId: number;
  title: string;
  subtitle: string;
  discount: string;
  badge: string;
  badgeColor: string;
  color: string;
  colorSecondary: string;
  endsAt: string;
  image: string;
  code?: string;
  savedAt: string;
}

export const savedPromos: SavedPromo[] = [
  {
    id: 1, promoId: 1,
    title: 'СУПЕРСКИДКИ НА ВИТАМИНЫ',
    subtitle: 'До -40% на весь ассортимент',
    discount: '-40%', badge: 'ГОРЯЧЕЕ ПРЕДЛОЖЕНИЕ', badgeColor: '#ff2d78',
    color: '#ff2d78', colorSecondary: '#ff6b00',
    endsAt: '2026-04-12T23:59:59',
    image: 'https://readdy.ai/api/search-image?query=vitamin%20supplement%20bottles%20capsules%20glowing%20pink%20orange%20neon%20light%20dark%20background%20cyberpunk%20pharmacy%20product%20display%20artistic%20minimal&width=800&height=420&seq=promo-banner-1&orientation=landscape',
    code: 'VIT40', savedAt: '5 апреля 2026',
  },
  {
    id: 2, promoId: 2,
    title: 'НЕДЕЛЯ СЕРДЦА',
    subtitle: 'Кардиопрепараты со скидкой до -30%',
    discount: '-30%', badge: 'СПЕЦИАЛЬНАЯ АКЦИЯ', badgeColor: '#00f5ff',
    color: '#00f5ff', colorSecondary: '#39ff14',
    endsAt: '2026-04-15T23:59:59',
    image: 'https://readdy.ai/api/search-image?query=heart%20health%20cardio%20medicine%20tablets%20glowing%20cyan%20neon%20dark%20background%20cyberpunk%20pharmacy%20product%20display%20artistic%20minimal&width=800&height=420&seq=promo-banner-2&orientation=landscape',
    code: 'HEART30', savedAt: '3 апреля 2026',
  },
  {
    id: 3, promoId: 3,
    title: 'АПТЕКА ВЫХОДНОГО ДНЯ',
    subtitle: 'Скидка 25% каждую субботу и воскресенье',
    discount: '-25%', badge: 'КАЖДЫЕ ВЫХОДНЫЕ', badgeColor: '#39ff14',
    color: '#39ff14', colorSecondary: '#f0ff00',
    endsAt: '2026-04-07T23:59:59',
    image: 'https://readdy.ai/api/search-image?query=pharmacy%20weekend%20sale%20medicine%20bottles%20glowing%20green%20yellow%20neon%20dark%20background%20cyberpunk%20minimal%20artistic%20product%20display&width=800&height=420&seq=promo-banner-3&orientation=landscape',
    savedAt: '1 апреля 2026',
  },
];

export const bonusHistory = [
  { id: 1, date: '12 марта 2026', type: 'earned', amount: 85, label: 'Заказ NP-2026-0312', color: '#39ff14' },
  { id: 2, date: '28 февраля 2026', type: 'earned', amount: 129, label: 'Заказ NP-2026-0287', color: '#39ff14' },
  { id: 3, date: '14 февраля 2026', type: 'spent', amount: -500, label: 'Оплата баллами', color: '#ff2d78' },
  { id: 4, date: '14 февраля 2026', type: 'earned', amount: 44, label: 'Заказ NP-2026-0241', color: '#39ff14' },
  { id: 5, date: '18 января 2026', type: 'earned', amount: 203, label: 'Заказ NP-2026-0156', color: '#39ff14' },
  { id: 6, date: '1 января 2026', type: 'earned', amount: 150, label: 'Бонус ко дню рождения', color: '#f0ff00' },
  { id: 7, date: '15 декабря 2025', type: 'spent', amount: -300, label: 'Оплата баллами', color: '#ff2d78' },
  { id: 8, date: '10 декабря 2025', type: 'earned', amount: 178, label: 'Заказ NP-2025-0891', color: '#39ff14' },
];
